<template>
  <v-app id="creditcard">
    <v-content class="good-gray">
      <div id="payment-container">
        <v-alert text :color="v_alert.color" border="left" :type="v_alert.type"
                 class="pa-6 mx-5 w-100" v-if="v_alert.displayed">{{v_alert.text}}
        </v-alert>
        <p>Steppi</p>
        <h2>Steppi B.V.</h2>
        <h2>Credit Card</h2>
        <h2>€ {{amount}}</h2>
          <div class="payment-line">
            <v-text-field
                label="Kaart nummer"
                v-model="card.number" required outlined>
            </v-text-field>
            <v-menu ref="menu"
                    :close-on-content-click="false"
                    transition="scale-transition" offset-y
                    min-width="290px">
              <template  v-slot:activator="{ on }">
                <v-text-field label="Verval datum "
                              v-on="on" v-on:blur="menu=true"
                               outlined v-model="hiddenDate">
                </v-text-field>
              </template>
              <v-date-picker ref="picker"
                             v-model="card.month"
                             :hasInputElement="true" type="month"
                             min="2020-11" @change="save">

              </v-date-picker>
            </v-menu>
            <v-text-field
                          label="CVC code"
                          v-model="card.cvc" required outlined>
            </v-text-field>
            <v-btn text @click="back()">Terug</v-btn>
            <v-btn color="primary" style="float: right"  @click="pay()">Betaal</v-btn>
          </div>
        </div>
    </v-content>
  </v-app>
</template>

<script src="https://js.stripe.com/v3/"></script>
<script>
import {mapActions, mapState} from "vuex";

export default {
  data: () => ({
    paymentId: "",
    payment: '',
    amount: "",
    card:{
      cvc: "",
      date: "",
      number: "",
    },
    hiddenDate: "",
    v_alert: {
      color: "",
      type: "",
      text: "",
      displayed: false,
    },
    url: null,
  }),
  mounted() {
    this.paymentId = this.$route.params.id;
    this.url = this.$route.params.secret;

    console.log(this.url);
    if(this.paymentId===undefined){
      this.redirectCountry();
    }else{
      this._getPaymentById(this.paymentId)
          .then((data) => {
            if(!data){
              this.redirectCountry();
            }else{
              this.payment = data;

              this.amount = data.total.toString();

              if(this.amount.includes('.')){
                this.amount = this.amount.replace('.', ',');
              }else{
                this.amount = data.total + ',00';
              }
            }
          })
          .catch(() => {

          });
    }
  },
  computed: {
    ...mapState({
    })
  },
  methods: {
    ...mapActions('payment', [
      '_creditcardPayment',
      '_getPaymentById'
    ]),
    pay(){
      this.loading();
      this._creditcardPayment([this.card, this.payment])
          .then((link) => {
            if(link){
              this.perfect();
              this.$router.push({ name: 'link-done'});
            }else{
              this.perfect();
              this.$router.push({ name: 'status'});
            }
          })
          .catch(() => {
            this.wrongCreditcard();
          });
    },
    save(date) {
      this.card.date = date;
      let dates = date.split('-');
      this.hiddenDate = dates[1] + '-' + dates[0];
    },
    back(){
      if(this.url === null || this.url === undefined){
          this.$router.push({ name: 'payment', params: { payment: this.payment }})
      }else{
        this.$router.push({ name: 'payment-link', params: { id: this.paymentId, secret: this.url }});

      }
    },
    wrongCreditcard(){
      this.v_alert.color = "red";
      this.v_alert.type = "error";
      this.v_alert.text = "Uw creditcard informatie is verkeerd";
      this.v_alert.displayed = true;
    },
    loading(){
      this.v_alert.color = "blue";
      this.v_alert.type = "info";
      this.v_alert.text = "Uw gegevens worden geverifieerd";
      this.v_alert.displayed = true;
    },
    perfect(){
      this.v_alert.color = "green";
      this.v_alert.type = "success";
      this.v_alert.text = "Het koppelen van uw creditcard is gelukt";
      this.v_alert.displayed = true;
    },
  }
};
</script>
<style src="../Payment/Payment.scss" scoped lang="scss"></style>
<style src="../PaymentMethods/CreditCard.scss" scoped lang="scss"></style>

